import caller from "../../helpers/caller";

export default async function getCheckAvailableDocumentSubType(api) {
  const response = await caller(api.get, "/document_sub_type/has_available");
  // Data: true or false
  return response;
}
